import {
  Button,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Text,
  Box,
  useBreakpointValue,
  UnorderedList,
  ListItem,
} from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { ModalProps } from "../../../../components/modals/confirm/ConfirmModal";
import { analyticsGA4 } from "../../../../tracking/analytics";
import { cta_click } from "../../../../tracking/ga4/events/other";
import { useApplicationLinks } from "v2/settings/applicationLinks";

const documentsList = ["passport", "visa", "return_ticket", "covid_test", "locator_form"];

export function OverbookBlockModal({ isOpen, onClose, onConfirm }: ModalProps) {
  const { t } = useTranslation();
  const { deniedBoardingCompensation } = useApplicationLinks();
  const buttonSize = useBreakpointValue(["s", "m"]);

  return (
    <Modal isOpen={isOpen} onClose={onClose} isCentered={true} scrollBehavior="inside">
      <ModalOverlay />
      <ModalContent
        data-testid="overbookingModalContent"
        height="auto"
        maxH="-webkit-fill-available"
      >
        <ModalCloseButton />
        <ModalHeader>
          <Text fontWeight="bold" fontSize="20px">
            {t("steps.claim_type.modals.overbooked.title")}
          </Text>
        </ModalHeader>
        <ModalBody>
          <Box mt={2}>
            <Text variant="medium">{t("steps.claim_type.modals.overbooked.explanation")}</Text>
            <Text mt={5} fontWeight="bold" variant="medium">
              {t("steps.claim_type.modals.overbooked.list_title")}
            </Text>
          </Box>
          <Box ml={2} mt={5}>
            <UnorderedList listStyleType="none" ml="0">
              {documentsList.map((item) => (
                <ListItem
                  key={item}
                  mt="8px"
                  display="flex"
                  fontSize={14}
                  _first={{ marginTop: 0 }}
                  _before={{
                    content: "'\\2022'",
                    color: "primary.900",
                    fontWeight: "bold",
                    lineHeight: 0,
                    marginTop: "11px",
                    marginRight: "16px",
                    verticalAlign: "-1px",
                  }}
                >
                  <span>{t(`steps.claim_type.modals.overbooked.documents_list.${item}`)}</span>
                </ListItem>
              ))}
            </UnorderedList>
          </Box>
        </ModalBody>
        <ModalFooter display="flex" flexDirection={{ base: "column", md: "row" }}>
          <Button
            variant="secondary"
            size={buttonSize}
            cursor={"pointer"}
            _focus={{ boxShadow: "none" }}
            name="Overbook modal exit"
            onClick={() => {
              analyticsGA4.track("cta_click", cta_click("Exit", "Overbook modal"));
              window.location.href = deniedBoardingCompensation;
            }}
          >
            {t("steps.claim_type.modals.overbooked.exit")}
          </Button>
          <Button
            variant="primary"
            name="Overbook modal continue"
            size={buttonSize}
            cursor={"pointer"}
            sx={{
              "&:focus": {
                boxShadow: "none",
              },
            }}
            onClick={() => {
              analyticsGA4.track("cta_click", cta_click("Continue", "Overbook modal"));
              onConfirm();
            }}
          >
            {t("steps.claim_type.modals.overbooked.continue")}
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}
